<script lang="ts">
  import KeyboardHint from '$icons/KeyboardHintIcon.svelte';
  import { createEventDispatcher } from 'svelte';
  import Modal from '../Modals/SmallModal/Modal.svelte';
  import type { FPost } from 'garden-common';
  import PostInfoBox from './PostInfoBox.svelte';
  import Button from '../common/buttons/Button.svelte';

  export let post: Partial<FPost<string>>;

  const dispatch = createEventDispatcher();
</script>

<Modal class="w-full min-w-[30vw] max-w-[50vw]" on:ModalClose footerBorder>
  <div slot="header" class="text-blueish-grey-900 font-bold text-lg">Delete your post?</div>

  <div slot="content" class="content-step-request p-5 overflow-y-clip">
    <PostInfoBox bind:post />
    <div class="font-bold text-garden-grey-800 pt-6 pb-2">Are you sure?</div>
    <div class="text-garden-grey-600 text-xs">
      We will be deleting this post if you continue, please be sure this is what you want.
    </div>
  </div>

  <div slot="footer" class="w-full flex justify-end gap-2 pr-5 pt-4">
    <Button
      danger
      secondary
      label="Delete"
      on:click={() => {
        dispatch('DeletePost');
        dispatch('ModalClose');
      }} />
    <Button
      primary
      clickOnKey="Enter"
      on:click={() => {
        dispatch('ModalClose');
      }}
      label="Keep details"
      iconRight={KeyboardHint}
    />
  </div>
</Modal>

<style type="postcss">
  .content-step-request {
    @apply h-[50vh] pt-10;
  }
</style>
